import {
  CreateCartMutation,
  CreateCartMutationVariables,
  SetBuyerIdentityMutation,
  SetBuyerIdentityMutationVariables,
} from "./shopify-storefront.graphql";
import { ShopifyStorefrontClient } from "./storefront-client";

const createCartMutation = /* GraphQL */ `
  mutation CreateCart($input: CartInput) {
    cartCreate(input: $input) {
      cart {
        id
        checkoutUrl
      }
    }
  }
`;

const setBuyerIdentityMutation = /* GraphQL */ `
  mutation SetBuyerIdentity(
    $cartId: ID!
    $buyerIdentity: CartBuyerIdentityInput!
  ) {
    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
      userErrors {
        field
        message
      }
    }
  }
`;
//
export async function createCart(
  client: ShopifyStorefrontClient,
  buyerIdentity: SetBuyerIdentityMutationVariables["buyerIdentity"],
  input?: CreateCartMutationVariables["input"],
): Promise<{ id: string; checkoutUrl: string }> {
  const { data: cartCreateData, errors: cartCreateErrors } =
    await client.request<CreateCartMutation, CreateCartMutationVariables>(
      createCartMutation,
      { input },
    );

  if (cartCreateErrors) {
    throw cartCreateErrors;
  }

  if (!cartCreateData?.cartCreate?.cart) {
    throw new Error("Cart not created");
  }
  const cart = cartCreateData.cartCreate.cart;

  const { data, errors } = await client.request<
    SetBuyerIdentityMutation,
    SetBuyerIdentityMutationVariables
  >(setBuyerIdentityMutation, { cartId: cart.id, buyerIdentity });
  const userErrors = data?.cartBuyerIdentityUpdate?.userErrors;
  if (userErrors && userErrors.length > 0) {
    console.error("Error setting buyer identity", errors);
  }
  return cart;
}

export async function createCartSimple(
  client: ShopifyStorefrontClient,
  input?: CreateCartMutationVariables["input"],
): Promise<{ id: string; checkoutUrl: string }> {
  const { data, errors } = await client.request<
    CreateCartMutation,
    CreateCartMutationVariables
  >(createCartMutation, { input });

  if (errors) {
    throw errors;
  }

  if (!data?.cartCreate?.cart) {
    throw new Error("Cart not created");
  }
  const cart = data.cartCreate.cart;

  return cart;
}
